import { textureCategories, textureTutorials } from "../data/texturesData";

export const SITE_URL = "https://colobongo.ca";

const STATIC_INDEXABLE_ROUTES = new Set([
  "/",
  "/studio",
  "/palettes",
  "/light-helper",
  "/textures",
  "/effets",
  "/wheel",
  "/application-coloriage-papier",
  "/scan-coloriage-ia",
  "/mur",
  "/privacy",
  "/terms",
  "/cookies"
]);

const STATIC_NOINDEX_ROUTES = new Set([
  "/auth",
  "/settings",
  "/profile",
  "/install",
  "/admin-showcase",
  "/admin/defi-mensuel",
  "/showcase/coloring-of-the-month",
  "/scan",
  "/gallery",
  "/completed-challenges",
  "/challenge",
  "/shade-builder"
]);

function normalizePath(pathname = "/") {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

function createSeo({ title, description, index = true, canonicalPath = "/" }) {
  return {
    title,
    description,
    robots: index ? "index,follow" : "noindex,nofollow",
    canonical: `${SITE_URL}${canonicalPath}`,
    index
  };
}

function clipDescription(value = "", max = 170) {
  const text = String(value).replace(/\s+/g, " ").trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trim()}…`;
}

function localizedTexts(language) {
  const isFr = language === "fr";
  return {
    homeTitle: isFr
      ? "ColoBongo | Défis de coloriage papier et shading"
      : "ColoBongo | Paper coloring challenges and shading",
    homeDesc: isFr
      ? "Application de coloriage papier avec défis créatifs, palettes de marqueurs alcool, aide lumière 3D et tutoriels textures."
      : "Paper coloring app with creative challenges, alcohol marker palettes, 3D light helper, and texture tutorials.",
    studioTitle: isFr ? "Studio ColoBongo | Outils de coloriage papier" : "ColoBongo Studio | Paper coloring tools",
    studioDesc: isFr
      ? "Accède aux palettes, textures, aide lumière et outils pratiques pour progresser en coloriage papier au marqueur alcool."
      : "Access palettes, texture tutorials, light helper, and practical tools to improve paper coloring with alcohol markers.",
    palettesTitle: isFr
      ? "Palettes marqueurs alcool | Ohuhu, Copic, Prismacolor | ColoBongo"
      : "Alcohol marker palettes | Ohuhu, Copic, Prismacolor | ColoBongo",
    palettesDesc: isFr
      ? "Trouve des palettes de couleurs prêtes à l’emploi pour le coloriage papier avec marqueurs Ohuhu, Copic et Prismacolor."
      : "Find ready-to-use color palettes for paper coloring with Ohuhu, Copic, and Prismacolor markers.",
    lightTitle: isFr
      ? "Aide lumière 3D | Ombres et highlights au marqueur | ColoBongo"
      : "3D Light Helper | Marker shadows and highlights | ColoBongo",
    lightDesc: isFr
      ? "Visualise angle de lumière, hauteur et rotation 3D pour comprendre ombres, tons moyens et highlights au marqueur alcool."
      : "Visualize light angle, height, and 3D rotation to understand shadows, midtones, and highlights with alcohol markers.",
    texturesTitle: isFr
      ? "Textures et motifs | Tutoriels coloriage marqueurs alcool | ColoBongo"
      : "Textures and patterns | Alcohol marker coloring tutorials | ColoBongo",
    texturesDesc: isFr
      ? "Tutoriels pas à pas pour apprendre les textures en coloriage papier : eau, bois, tissu, herbe, ciel, verre et plus."
      : "Step-by-step paper coloring texture tutorials: water, wood, fabric, grass, sky, glass, and more.",
    effectsTitle: isFr
      ? "Effets et techniques | Tutoriels coloriage marqueurs alcool | ColoBongo"
      : "Effects and techniques | Alcohol marker coloring tutorials | ColoBongo",
    effectsDesc: isFr
      ? "Tutoriels pas à pas pour apprendre des effets complets de coloriage papier : Rainbow Monochrome, verre cassé, rayons de soleil, dégradés et plus."
      : "Step-by-step paper coloring effect tutorials: Rainbow Monochrome, broken glass, sun rays, gradients, and more.",
    wheelTitle: isFr
      ? "Roue de défis coloriage | Idées et exercices rapides | ColoBongo"
      : "Coloring challenge wheel | Quick ideas and drills | ColoBongo",
    wheelDesc: isFr
      ? "Tire un défi créatif de coloriage pour pratiquer shading, palettes et textures au marqueur alcool chaque jour."
      : "Spin a creative coloring prompt to practice shading, palettes, and texture techniques with alcohol markers daily.",
    paperColoringAppTitle: isFr
      ? "Application coloriage papier | Outils pour coloriste | ColoBongo"
      : "Paper coloring app | Tools for colorists | ColoBongo",
    paperColoringAppDesc: isFr
      ? "ColoBongo est une application web pour coloristes papier : scan IA encourageant, palettes, textures, aide lumière 3D et Colomunauté cozy."
      : "ColoBongo is a web app for paper colorists: encouraging AI scan, palettes, textures, 3D light helper, and a cozy Colomunauty.",
    aiScanTitle: isFr
      ? "Scan coloriage IA | Analyse non jugeante | ColoBongo"
      : "AI coloring scan | Gentle non-judgmental analysis | ColoBongo",
    aiScanDesc: isFr
      ? "Analyse coloriage IA douce et indicative : score, feedback encourageant, pistes concrètes pour progresser sans jugement."
      : "Gentle and indicative AI coloring analysis: score, encouraging feedback, and practical ideas to improve without judgment.",
     wallTitle: isFr ? "Le Mur | Colomunaut\u00e9" : "Le Mur | Colomunauty",
    wallDesc: isFr
 ? "Le Mur est l’espace Colomunautaire avec des coloriages approuvés manuellement et mis en avant pendant 30 jours."
      : "Le Mur is the Colomunauty wall with manually approved colorings featured for 30 days.",
    privacyTitle: isFr ? "Politique de confidentialité | ColoBongo" : "Privacy Policy | ColoBongo",
    termsTitle: isFr ? "Conditions d’utilisation | ColoBongo" : "Terms of Service | ColoBongo",
    cookiesTitle: isFr ? "Politique cookies | ColoBongo" : "Cookies Policy | ColoBongo",
    legalDesc: isFr
      ? "Informations légales et conditions d’utilisation de l’application ColoBongo."
      : "Legal information and terms of use for the ColoBongo application.",
    textureTitlePrefix: isFr ? "Tutoriel texture marqueurs alcool" : "Alcohol marker texture tutorial",
    textureDescPrefix: isFr
      ? "Apprends à reproduire cette texture en coloriage papier avec des marqueurs alcool."
      : "Learn how to recreate this texture in paper coloring with alcohol markers."
  };
}

function getTextureSeo(pathname, language) {
  const texts = localizedTexts(language);
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "textures") return null;
  if (parts.length === 1) {
    return createSeo({
      title: texts.texturesTitle,
      description: texts.texturesDesc,
      canonicalPath: "/textures"
    });
  }

  const slug = parts[1];
  if (!slug) return null;

  if (parts.length >= 3 && (parts[2] === "scan" || parts[2] === "result")) {
    return createSeo({
      title: "ColoBongo",
      description: texts.texturesDesc,
      index: false,
      canonicalPath: `/textures/${slug}`
    });
  }

  const category = textureCategories.find((item) => item.slug === slug);
  const tutorial = textureTutorials[slug];

  if (!category || !tutorial) {
    return createSeo({
      title: texts.texturesTitle,
      description: texts.texturesDesc,
      index: false,
      canonicalPath: "/textures"
    });
  }

  const isFr = language === "fr";
  const textureName = tutorial.title?.[isFr ? "fr" : "en"] || category.name?.[isFr ? "fr" : "en"] || slug;
  const textureDesc = tutorial.intro?.[isFr ? "fr" : "en"] || texts.textureDescPrefix;
  const detailTitle = `${textureName} | ${texts.textureTitlePrefix} | ColoBongo`;

  return createSeo({
    title: detailTitle,
    description: clipDescription(textureDesc),
    canonicalPath: `/textures/${slug}`
  });
}

// CODEX_PROMPT_87 : SEO de la section Effets & Techniques. La liste est
// dynamique (table Supabase), donc les fiches /effets/:slug ne peuvent pas
// recevoir de meta specifiques ici (fonction synchrone) : elles reprennent le
// titre generique en noindex, seule la grille /effets est indexable.
function getEffectSeo(pathname, language) {
  const texts = localizedTexts(language);
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "effets") return null;
  if (parts.length === 1) {
    return createSeo({
      title: texts.effectsTitle,
      description: texts.effectsDesc,
      canonicalPath: "/effets"
    });
  }

  return createSeo({
    title: texts.effectsTitle,
    description: texts.effectsDesc,
    index: false,
    canonicalPath: "/effets"
  });
}

export function getSeoForPath(pathname, language = "fr") {
  const path = normalizePath(pathname);
  const texts = localizedTexts(language);

  if (path.startsWith("/admin")) {
    return createSeo({
      title: "ColoBongo",
      description: texts.homeDesc,
      index: false,
      canonicalPath: path
    });
  }

  const textureSeo = getTextureSeo(path, language);
  if (textureSeo) return textureSeo;

  const effectSeo = getEffectSeo(path, language);
  if (effectSeo) return effectSeo;

  if (STATIC_INDEXABLE_ROUTES.has(path)) {
    switch (path) {
      case "/":
        return createSeo({ title: texts.homeTitle, description: texts.homeDesc, canonicalPath: "/" });
      case "/studio":
        return createSeo({ title: texts.studioTitle, description: texts.studioDesc, canonicalPath: "/studio" });
      case "/palettes":
        return createSeo({
          title: texts.palettesTitle,
          description: texts.palettesDesc,
          canonicalPath: "/palettes"
        });
      case "/light-helper":
        return createSeo({ title: texts.lightTitle, description: texts.lightDesc, canonicalPath: "/light-helper" });
      case "/textures":
        return createSeo({
          title: texts.texturesTitle,
          description: texts.texturesDesc,
          canonicalPath: "/textures"
        });
      case "/effets":
        return createSeo({
          title: texts.effectsTitle,
          description: texts.effectsDesc,
          canonicalPath: "/effets"
        });
      case "/wheel":
        return createSeo({ title: texts.wheelTitle, description: texts.wheelDesc, canonicalPath: "/wheel" });
      case "/application-coloriage-papier":
        return createSeo({
          title: texts.paperColoringAppTitle,
          description: texts.paperColoringAppDesc,
          canonicalPath: "/application-coloriage-papier"
        });
      case "/scan-coloriage-ia":
        return createSeo({
          title: texts.aiScanTitle,
          description: texts.aiScanDesc,
          canonicalPath: "/scan-coloriage-ia"
        });
      case "/mur":
        return createSeo({
          title: texts.wallTitle,
          description: texts.wallDesc,
          canonicalPath: "/mur"
        });
      case "/privacy":
        return createSeo({ title: texts.privacyTitle, description: texts.legalDesc, canonicalPath: "/privacy" });
      case "/terms":
        return createSeo({ title: texts.termsTitle, description: texts.legalDesc, canonicalPath: "/terms" });
      case "/cookies":
        return createSeo({ title: texts.cookiesTitle, description: texts.legalDesc, canonicalPath: "/cookies" });
      default:
        break;
    }
  }

  if (STATIC_NOINDEX_ROUTES.has(path)) {
    return createSeo({
      title: "ColoBongo",
      description: texts.homeDesc,
      index: false,
      canonicalPath: path
    });
  }

  return createSeo({
    title: "ColoBongo",
    description: texts.homeDesc,
    index: false,
    canonicalPath: "/"
  });
}

export function getSitemapPublicPaths() {
  const basePaths = [
    "/",
    "/studio",
    "/palettes",
    "/light-helper",
    "/textures",
    "/effets",
    "/wheel",
    "/application-coloriage-papier",
    "/scan-coloriage-ia",
    "/mur",
    "/privacy",
    "/terms",
    "/cookies"
  ];
  const texturePaths = textureCategories.map((item) => `/textures/${item.slug}`);
  return [...basePaths, ...texturePaths];
}

export function getSitemapExcludedPaths() {
  return [
    "/auth",
    "/settings",
    "/profile",
    "/install",
    "/admin-showcase",
    "/admin",
    "/admin/defi-mensuel",
    "/admin/effets",
    "/scan",
    "/gallery",
    "/completed-challenges",
    "/challenge",
    "/shade-builder",
    "/textures/:slug/scan",
    "/textures/:slug/result"
  ];
}
